import { useSearchState } from '~/features/search/hooks/useSearchState';
import SearchIcon from '~/icons/search.svg';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';

import IMainMenuSearchButton from './MainMenuSearchButton.def';
import styles from './mainMenuSearchButton.module.css';

const MainMenuSearchButton = ({ onOpen }: IMainMenuSearchButton) => {
	const { translate } = useTranslation();
	const openSearchDialog = useSearchState((state) => state.openDialog);

	const handleOpen = () => {
		onOpen?.();
		openSearchDialog();
	};

	return (
		<div className={styles.root}>
			<button
				type="button"
				className={styles.searchButton}
				onClick={handleOpen}
			>
				<SearchIcon className={styles.searchIcon} />

				<span>{translate('search.menu-label')}</span>
			</button>
		</div>
	);
};

export default MainMenuSearchButton;
